// Переключение цвета шапки в зависимости от секции под ней
// (data-header="light" — белый текст шапки, "dark" — чёрный)
const header = document.getElementById('header');
const observed = document.querySelectorAll('[data-header]');

if (header) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          header.classList.toggle('is-light', entry.target.dataset.header === 'light');
        }
      });
    },
    // срабатывает, когда верх секции проходит под шапкой
    { rootMargin: '-1% 0px -95% 0px', threshold: 0 }
  );
  observed.forEach((s) => observer.observe(s));
}

// Мобильное меню
const burger = document.getElementById('burger');
const mobileMenu = document.getElementById('mobileMenu');
if (burger && mobileMenu) {
  burger.addEventListener('click', () => mobileMenu.classList.toggle('is-open'));
}

// Куки-плашка (есть только на главной)
const cookie = document.getElementById('cookie');
if (cookie) {
  document.getElementById('cookieAccept').addEventListener('click', () => cookie.classList.add('is-hidden'));
  document.getElementById('cookieClose').addEventListener('click', () => cookie.classList.add('is-hidden'));
}

// ------------------------------------------------------------
// Страница продукта: выбор цвета/размера/количества.
// Данные и id вариантов лежат в <script id="productData">.
// Кнопка "Add to cart" ведёт на нативную ссылку Shopify
// /cart/{variantId}:{qty} — совместимо с площадкой без бэкенда.
// ------------------------------------------------------------
const productEl = document.querySelector('[data-product]');
const productDataEl = document.getElementById('productData');

if (productEl && productDataEl) {
  const data = JSON.parse(productDataEl.textContent);

  const gallery    = productEl.querySelector('[data-gallery]');
  const colorWrap  = productEl.querySelector('[data-colors]');
  const colorLabel = productEl.querySelector('[data-color-label]');
  const sizeWrap   = productEl.querySelector('[data-sizes]');
  const qtyValue   = productEl.querySelector('[data-qty]');
  const qtyDec     = productEl.querySelector('[data-qty-dec]');
  const qtyInc     = productEl.querySelector('[data-qty-inc]');
  const addBtn     = productEl.querySelector('[data-add-to-cart]');

  const state = { color: data.order[0], size: null, qty: 1 };

  function renderGallery() {
    const imgs = data.colors[state.color].images;
    gallery.innerHTML = imgs
      .map((o) => `<img src="${o.src}" alt="${o.alt}">`)
      .join('');
  }

    function currentVariantId() {
    const variants = data.colors[state.color].variants;
    return state.size ? variants[state.size] : null;
  }

  function updateAddBtn() {
    const variantId = currentVariantId();
    if (variantId) {
      // /cart/add — ДОБАВЛЯЕТ товар в корзину (не заменяет её). Fallback без JS.
      addBtn.href = `${data.cartBase}/add?id=${variantId}&quantity=${state.qty}`;
      addBtn.classList.remove('is-disabled');
      addBtn.removeAttribute('aria-disabled');
      addBtn.textContent = 'Add to cart';
    } else {
      addBtn.href = '#';
      addBtn.classList.add('is-disabled');
      addBtn.setAttribute('aria-disabled', 'true');
      addBtn.textContent = 'Select a size';
    }
  }

  colorWrap.querySelectorAll('[data-color]').forEach((btn) => {
    btn.addEventListener('click', () => {
      state.color = btn.dataset.color;
      colorWrap.querySelectorAll('[data-color]')
        .forEach((b) => b.classList.toggle('is-selected', b === btn));
      if (colorLabel) colorLabel.textContent = state.color;
      renderGallery();
      updateAddBtn();
    });
  });

  sizeWrap.querySelectorAll('[data-size]').forEach((span) => {
    span.addEventListener('click', () => {
      state.size = span.dataset.size;
      sizeWrap.querySelectorAll('[data-size]')
        .forEach((s) => s.classList.toggle('is-selected', s === span));
      updateAddBtn();
    });
  });

  qtyDec.addEventListener('click', () => {
    state.qty = Math.max(1, state.qty - 1);
    qtyValue.textContent = state.qty;
    updateAddBtn();
  });
  qtyInc.addEventListener('click', () => {
    state.qty = Math.min(10, state.qty + 1);
    qtyValue.textContent = state.qty;
    updateAddBtn();
  });

      addBtn.addEventListener('click', (e) => {
    if (addBtn.classList.contains('is-disabled')) {
      e.preventDefault();
      sizeWrap.classList.add('needs-attention');
      setTimeout(() => sizeWrap.classList.remove('needs-attention'), 1200);
      return;
    }
    const variantId = currentVariantId();
    if (!variantId) return;
    // Добавляем через Cart AJAX API: корзина ДОПОЛНЯЕТСЯ, а не перезаписывается,
    // затем переходим на страницу корзины (Bag).
    e.preventDefault();
    addBtn.textContent = 'Adding…';
    fetch(`${data.cartBase}/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: state.qty })
    })
      .then((r) => { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(() => { window.location.href = data.cartBase; })
      .catch(() => { window.location.href = addBtn.href; });
  });

  renderGallery();
  updateAddBtn();
}
